module.exports = __webpack_public_path__ + "static/media/antique_elegance_1.d34272e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/antique_elegance_1.jpg
// module id = 149
// module chunks = 0